export default [// 用户中心
{
  path: '',
  component: function component() {
    return import('../views/user/Home.vue');
  },
  children: [{
    path: "",
    name: "index",
    redirect: "index"
  }, {
    path: 'index',
    name: "index",
    component: function component() {
      return import('../views/user/index/Index.vue');
    },
    meta: {
      title: '首页',
      index: 0,
      keepAlive: true
    }
  }, {
    path: 'dynamic',
    name: "dynamic",
    component: function component() {
      return import('../views/user/dynamic/Dynamic.vue');
    },
    meta: {
      title: '动态',
      index: 1,
      keepAlive: true
    }
  }, {
    path: 'articles',
    name: "articles",
    component: function component() {
      return import('../views/user/dynamic/DynamicDetail.vue');
    },
    meta: {
      title: '动态',
      index: 4
    }
  }, {
    path: 'about',
    name: "about",
    component: function component() {
      return import('../views/user/about/About.vue');
    },
    meta: {
      title: '关于我们',
      index: 2,
      keepAlive: true
    }
  }, {
    path: 'contact',
    name: "contact",
    component: function component() {
      return import('../views/user/contact/Contact.vue');
    },
    meta: {
      title: '联系我们',
      index: 3,
      keepAlive: true
    }
  }, {
    path: 'intimate',
    name: "intimate",
    component: function component() {
      return import('../views/user/intimate/Intimate.vue');
    },
    meta: {
      title: '贴心健康',
      index: 5,
      keepAlive: true
    }
  }, // 类目
  {
    path: 'category',
    name: "category",
    component: function component() {
      return import('../views/user/intimate/Category.vue');
    },
    meta: {
      title: '贴心健康商品类目',
      index: 6
    }
  }, {
    path: 'diagnosis',
    name: "diagnosis",
    component: function component() {
      return import('../views/user/diagnosis/Diagnosis.vue');
    },
    meta: {
      title: '9号云诊',
      index: 7,
      keepAlive: true
    }
  }]
}];